export const REVIEWS_CSV_HEADERS = ['USER', 'REVIEW', 'RATING', 'DATE', 'SOURCE', 'CATEGORIES'];
